// extracted by mini-css-extract-plugin
module.exports = {"delete-action":"DeleteAction_delete-action__2b8Rr"};